export function getAdminListingCounts(listings = []) {
    const rows = Array.isArray(listings) ? listings : [];
    return {
        review: rows.filter((listing) => listing.status === "review").length,
        paymentPending: rows.filter((listing) => listing.status === "payment_pending").length,
        approved: rows.filter((listing) => listing.status === "approved").length,
        rejected: rows.filter((listing) => listing.status === "rejected").length,
        all: rows.length,
    };
}

export function filterAdminListings(listings = [], view = "review", search = "") {
    const statusByView = { review: "review", "payment-pending": "payment_pending", approved: "approved", rejected: "rejected" };
    const status = statusByView[view];
    const needle = String(search || "").trim().toLowerCase();
    return (Array.isArray(listings) ? listings : []).filter((listing) => {
        if (status && listing.status !== status) return false;
        if (!needle) return true;
        const text = [
            listing.shopName,
            listing.ownerName,
            listing.email,
            listing.address?.city,
            listing.address?.suburb,
            ...(Array.isArray(listing.selectedSupplies) ? listing.selectedSupplies : []),
            ...(Array.isArray(listing.customSupplies) ? listing.customSupplies : []),
        ].filter(Boolean).join(" ").toLowerCase();
        return text.includes(needle);
    });
}
